export default __webpack_public_path__ + "static/media/(43).6a7cdc89.jpg";